import React, {Fragment } from 'react';

import Payment from '../../../models/Payment';
import PaymentsPO from '../../../models/PaymentsPO';

import { Grid } from '@material-ui/core';

import { formatCurrency } from '../../../utils/currencyFormatter';

import style from './ordersStyle.module.css';
import commonStyles from '../../common/common.module.css';

interface OrderPaymentInformationProps {
  payments: PaymentsPO;
};

const orderPaymentInformation = (props: OrderPaymentInformationProps) => {

  return (

    <div className={`${ commonStyles.wrapper } ${ commonStyles.p4 }`}>
      <h1 className={ commonStyles.header }>Due and Pending Payment Information</h1>
    
      <Grid container>

        <Grid item md={3} xs={6} className={ style.paymentinfoGridItem }>
          <div className={ style.infoWrapper}>
            <div className={ style.pot }> Amount Due </div>
            <div className={ style.pod }> { formatCurrency(props.payments.totalDue, 2, '$') } </div>
          </div>
        </Grid>

        <Grid item md={3} xs={6} className={ style.paymentinfoGridItem }>
          <div className={ style.infoWrapper}>
            <div className={ style.pot }> Payment Confirmation</div>
            <div className={ style.pod }>{ formatCurrency(props.payments.totalPending, 2, '$') }</div>
          </div>
        </Grid>

        <Grid item md={3} xs={6} className={ style.paymentinfoGridItem }>
          { props.payments.payments.length > 0 && 
            <Fragment>
              { props.payments.payments.map((paymentDetails: Payment, index: number) => {
                  return <div key={ index } className={ style.paymentDetails }>
            
                    <div className={ style.infoWrapper }>
                      <div className={ style.pot }>Payment Method</div>
                      <div className={ style.pod }>{ paymentDetails.type }</div>
                    </div>

                  </div> 

                })
              }
            </Fragment>
          }
        </Grid>

        <Grid item md={3} xs={6} className={ style.paymentinfoGridItem }>
          { props.payments.payments.length > 0 && 
            <Fragment>
              { props.payments.payments.map((paymentDetails: Payment, index: number) => {
                  return <div key={ index } className={ style.paymentDetails }>
                    <div className={ style.infoWrapper }>
                      <div className={ style.pot }>Remarks</div>
                      <div className={ style.pod}>{ paymentDetails.payment_info }</div>
                    </div>
                  </div> 

                })
              }
            </Fragment>
          }
        </Grid>

      </Grid>
        
    </div>
  );
}

export default orderPaymentInformation;